import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_generation } from '@/hooks/store/use_slices';
import { useToast } from '@/hooks/use-toast';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { ENUM__generation_status } from '@shared/dto/generation/_enums/ENUM__generation_status';
import { useTranslation } from 'react-i18next';

export function WATCHER__generation_error() {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  /*
   * EVENTS
   */
  const { toast } = useToast();

  const { generation_current } = use_slice_generation(['generation_current']);

  use_effect(() => {
    if (generation_current.status != ENUM__generation_status.ERROR) return;

    toast({ title: t(i18n_base_ui.toasts.generation_status_failed.title) });
  }, [generation_current.status]);

  /*
   * EFFECTS
   */

  return <></>;
}
